import { GET_APP_CONFIGS, GET_APP_CONFIGS_SUCCESS, GET_APP_CONFIGS_ERROR, GET_APP_CONFIGS_SUCCESS_NO_UPDATE, GET_SITEMAP_DATA, GET_SITEMAP_DATA_SUCCESS, GET_SITEMAP_DATA_ERROR, } from '../../constants';
const initialState = {
    response: {},
    sitemapData: {},
    clientId: undefined,
    isLoading: false,
    error: false,
};
const appConfigsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_APP_CONFIGS:
        case GET_SITEMAP_DATA:
            return {
                ...state,
                isLoading: true,
            };
        case GET_APP_CONFIGS_SUCCESS: {
            const { result: { response, clientId } = {} } = action ?? {};
            return {
                ...state,
                response,
                clientId,
                isLoading: false,
                error: false,
            };
        }
        case GET_APP_CONFIGS_SUCCESS_NO_UPDATE: {
            return {
                ...state,
                isLoading: false,
                error: false,
            };
        }
        case GET_APP_CONFIGS_ERROR:
        case GET_SITEMAP_DATA_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
            };
        case GET_SITEMAP_DATA_SUCCESS: {
            const { result: { sitemapData = {} } = {} } = action ?? {};
            return {
                ...state,
                isLoading: false,
                error: false,
                sitemapData: sitemapData,
            };
        }
        default:
            return state;
    }
};
export default appConfigsReducer;
